import { jsx as _jsx } from "react/jsx-runtime";
import Loading from 'components/Loading';
import { txt } from 'libs/i18n';
import { EDITOR_ALERT_HEIGHT_LARGE, EDITOR_ALERT_HEIGHT_MEDIUM, EDITOR_ALERT_HEIGHT_SMALL } from 'screens/DashboardScreen/pages/EditorPage/EditorContent/editor-positions';
import { transcriptionSourceSignal } from 'screens/DashboardScreen/pages/EditorPage/signalsStore/transcriptionSource';
import ErrorAlert from './ErrorAlert';
import ProjectAlert from '../ProjectAlert';
export const getEditorAlertHeight = (mediaProcessingStatus, projectErrorStatus, projectQueuePosition, documentLoadingFinished, lock, showAiRetry = false) => {
    const isMicStreaming = projectErrorStatus !== 'no-error'
        && projectErrorStatus.reason === 'MissingRecording'
        && transcriptionSourceSignal.peek() === 'mic';
    const isFailedTranscriptionWarning = projectErrorStatus !== 'no-error'
        && projectErrorStatus.category === 'Client'
        && (projectErrorStatus.reason === 'FailedTranscriptionAccessDenied'
            || projectErrorStatus.reason === 'FailedTranscriptionPartialLoaded');
    const hasFatalError = projectErrorStatus !== 'no-error' && !isMicStreaming && !isFailedTranscriptionWarning;
    if (isFailedTranscriptionWarning && documentLoadingFinished) {
        return showAiRetry ? EDITOR_ALERT_HEIGHT_MEDIUM : EDITOR_ALERT_HEIGHT_SMALL;
    }
    if (hasFatalError && documentLoadingFinished) {
        return EDITOR_ALERT_HEIGHT_LARGE;
    }
    const isIdleWithNoMessage = mediaProcessingStatus === 'completed'
        && documentLoadingFinished
        && projectQueuePosition === null
        && !lock.isLocked
        && !isMicStreaming;
    if ((mediaProcessingStatus === 'words-arriving' && !lock.isLocked) || isIdleWithNoMessage) {
        return 0;
    }
    return EDITOR_ALERT_HEIGHT_SMALL;
};
const MessagePanel = ({ mediaProcessingStatus, projectErrorStatus, projectQueuePosition, documentLoadingFinished, onReupload, onTakeOverProject, lock, isReadOnly, isAfterUploadProfile, hasNoDocument, onRetry, onRetryAi, alternativeProfileName, retryLoading, }) => {
    const isMicStreaming = projectErrorStatus !== 'no-error'
        && projectErrorStatus.reason === 'MissingRecording'
        && transcriptionSourceSignal.peek() === 'mic';
    const isAfterUploadProcessing = isAfterUploadProfile
        && hasNoDocument
        && projectQueuePosition === null
        && (mediaProcessingStatus === 'loading-project' || mediaProcessingStatus === 'transcribing');
    if (projectErrorStatus !== 'no-error' && !isMicStreaming && documentLoadingFinished) {
        return (_jsx(ErrorAlert, { projectError: projectErrorStatus, onClick: onReupload, onRetry: onRetry, onRetryAi: onRetryAi, alternativeProfileName: alternativeProfileName, retryLoading: retryLoading }));
    }
    if (isAfterUploadProcessing) {
        return _jsx(Loading, { message: txt('displayAfterTranscription') });
    }
    if (projectQueuePosition !== null) {
        return (_jsx(ProjectAlert, { type: "info", title: txt('projectInQueue'), description: `${txt('orderInQueue')}: ${projectQueuePosition}` }));
    }
    if (lock.isLocked) {
        return (_jsx(ProjectAlert, { compact: true, type: "info", title: txt('lockedProject'), description: `${txt('heldBy')}: ${lock.holder.email}`, onClick: onTakeOverProject, lock: lock, isReadOnly: isReadOnly, isTranscriptionRunning: mediaProcessingStatus !== 'completed' }));
    }
    if (mediaProcessingStatus === 'words-arriving') {
        return null;
    }
    const isMic = transcriptionSourceSignal.peek() === 'mic';
    if (isMic && (projectErrorStatus === 'no-error' || isMicStreaming)) {
        return null;
    }
    if (!documentLoadingFinished) {
        return _jsx(Loading, { message: txt('loadingProject') });
    }
    if (mediaProcessingStatus === 'preparing-media') {
        return _jsx(Loading, { message: txt('converting') });
    }
    if (mediaProcessingStatus === 'loading-project') {
        return _jsx(Loading, { message: txt('loadingProject') });
    }
    if (mediaProcessingStatus === 'nofaststart-conversion') {
        return _jsx(Loading, { message: txt('waitingForConversion') });
    }
    if (mediaProcessingStatus === 'transcribing') {
        return _jsx(Loading, { message: txt('noWordsYet') });
    }
    return null;
};
export default MessagePanel;
